import { useState, useCallback } from 'react';

const TOAST_DURATION = 3000;

export const useToast = () => {
	const [toastInfo, setToastInfo] = useState({ message: null, type: 'info' });

	const showToast = useCallback((message, type = 'error') => {
		setToastInfo({ message, type });
		const timer = setTimeout(() => {
			setToastInfo({ message: null, type: 'info' });
		}, TOAST_DURATION);

		return () => clearTimeout(timer);
	}, []);

	const clearToast = useCallback(() => {
		setToastInfo({ message: null, type: 'info' });
	}, []);

	return { toastInfo, showToast, clearToast };
};
